import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { getGenres } from "../requests/genres"
import { API_Data_Genres_Response } from "@/interfaces/api/genres/api_response_types"

type GenresOptions = Omit<
  UseQueryOptions<API_Data_Genres_Response, API_Error, API_Data_Genres_Response, ['genres', string]>,
  'queryKey' | 'queryFn'
>

export const useGenres = (locale: string, options?: GenresOptions) => 
  useQuery<API_Data_Genres_Response, API_Error, API_Data_Genres_Response, ['genres', string]>({
    queryKey: ['genres', locale],
    retry: false,
    queryFn: () => getGenres(locale),
    ...options
  })